import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class LabelGenerationServices {
  updateLabelGeneration = async (payload) => {
    const updateLabel = await Helpers.put({
      url: Constants.LABEL_GENERATION,
      data: payload,
    });
    return updateLabel;
  }

  getLabelGeneration = async ({
    orgId, tenantId, entityName, labelTemplateId,
  }) => {
    let url = `${Constants.LABEL_GENERATION}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    if (labelTemplateId) url += `label_template_id=${labelTemplateId}&`;

    const labelGeneration = await Helpers.get({ url });
    return labelGeneration;
  }

  getGlobalLabels = async ({ entityName }) => {
    let url = `${Constants.GLOBAL_LABELS}?`;
    if (entityName) url += `entity_name=${entityName}&`;
    const globalLabels = await Helpers.get({ url });
    return globalLabels;
  }

  createLabel = async (payload) => {
    const createdLabels = await Helpers.post({
      url: Constants.LABEL_GENERATION,
      data: payload,
    });
    return createdLabels;
  }

  deleteLabel = async (payload) => {
    const deletedLabels = await Helpers.delete({
      url: Constants.LABEL_GENERATION,
      data: payload,
    });
    return deletedLabels;
  }
}

export default new LabelGenerationServices();
